module.exports = __webpack_public_path__ + "img/base_switch.c774e472.svg";